import { webview } from '@kk/utils';
import globalData from '@kk-activity-factory/global-data';

/**
 * 端外非QQ和微信环境，需要隐藏媒体模块
 */
export const needHiddenMeida = globalData.isOutside && !webview.isQQ && !webview.isWeixin;
